module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Itallic-1679a9c9e14db87a14d0e2d7b1f78b4e.svg";